module.exports = __webpack_public_path__ + "static/media/izmeritelnye_preobrazovateli_vl.95b5f707.pdf";